import { jsx } from "react/jsx-runtime";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { validateTidalLicense } from "../../base/index.js";
function ArrowUpward(props) {
  return /* @__PURE__ */ jsx(
    ArrowUpwardIcon,
    {
      "data-testid": "ArrowUpward",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ArrowUpward",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
ArrowUpward.tidalIconMeta = {
  categories: "arrows",
  name: "ArrowUpward"
};
validateTidalLicense();
export {
  ArrowUpward
};
//# sourceMappingURL=ArrowUpward.js.map
